import React from "react";
import '../../../../styles/styles.css'
import Navbar from "../../../Navbar/Navbar";

const Header = ({ borderRadius }) => {
  return (
    <div className="header" style={{ borderRadius: borderRadius }}>
      <Navbar></Navbar>
    </div>
  );
};
export default Header;
